"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSSIBLE_SIZES = void 0;
/**
 * Provider of various calculated values for sizing components based on the current viewport.
 * @module app/Page
 */
var $ = require("jquery");
var Evented_1 = require("./Evented");
/*!
 * modernizr v3.2.0
 * Build http://modernizr.com/download?-mq-dontmin
 *
 * Copyright (c)
 *  Faruk Ates
 *  Paul Irish
 *  Alex Sexton
 *  Ryan Seddon
 *  Patrick Kettner
 *  Stu Cox
 *  Richard Herrera

 * MIT License
 */
/*
 * Modernizr tests which native CSS3 and HTML5 features are available in the
 * current UA and makes the results available to you in two ways: as properties on
 * a global `Modernizr` object, and as classes on the `<html>` element. This
 * information allows you to progressively enhance your pages with a granular level
 * of control over the experience.
 */
var docElement = document.documentElement;
var isSVG = docElement.nodeName.toLowerCase() === "svg";
function createElement(tagName) {
    if (typeof document.createElement !== "function") {
        // This is the case in IE7, where the type of createElement is "object".
        // For this reason, we cannot call apply() as Object is not a Function.
        return document.createElement(tagName);
    }
    else if (isSVG) {
        return document.createElementNS.call(document, "http://www.w3.org/2000/svg", tagName);
    }
    else {
        return document.createElement.apply(document, arguments);
    }
}
function getBody() {
    // After page load injecting a fake body doesn't work so check if body exists
    var body = document.body;
    if (!body) {
        // Can't use the real body create a fake one.
        body = createElement(isSVG ? "svg" : "body");
        body.fake = true;
    }
    return body;
}
function injectElementWithStyles(rule, callback, nodes, testnames) {
    var mod = "modernizr";
    var style;
    var ret;
    var node;
    var docOverflow;
    var div = createElement("div");
    var body = getBody();
    if (parseInt(nodes, 10)) {
        // In order not to give false positives we create a node for each test
        // This also allows the method to scale for unspecified uses
        while (nodes--) {
            node = createElement("div");
            node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
            div.appendChild(node);
        }
    }
    style = createElement("style");
    style.type = "text/css";
    style.id = "s" + mod;
    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
    (!body.fake ? div : body).appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) {
        style.styleSheet.cssText = rule;
    }
    else {
        style.appendChild(document.createTextNode(rule));
    }
    div.id = mod;
    if (body.fake) {
        //avoid crashing IE8, if background image is used
        body.style.background = "";
        //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = "hidden";
        docOverflow = docElement.style.overflow;
        docElement.style.overflow = "hidden";
        docElement.appendChild(body);
    }
    ret = callback(div, rule);
    // If this is done after page load we don't want to remove the body so check if body exists
    if (body.fake) {
        body.parentNode.removeChild(body);
        docElement.style.overflow = docOverflow;
        // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        docElement.offsetHeight;
    }
    else {
        div.parentNode.removeChild(div);
    }
    return !!ret;
}
var mq = (function () {
    var wndow = window;
    var matchMedia = wndow.matchMedia || wndow.msMatchMedia;
    if (matchMedia) {
        return function (mq) {
            var mql = matchMedia(mq);
            return (mql && mql.matches) || false;
        };
    }
    return function (mq) {
        var bool = false;
        injectElementWithStyles("@media " + mq + " { #modernizr { position: absolute; } }", function (node) {
            bool =
                (window.getComputedStyle
                    ? window.getComputedStyle(node, null)
                    : node.currentStyle).position == "absolute";
        });
        return bool;
    };
})();
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the window height.
     * @return {number} The window height.
     */
    Page.prototype.getWindowHeight = function () {
        return $(window).height() - 1;
    };
    /**
     * Gets the header height.
     * @return {number} The header height.
     */
    Page.prototype.getHeaderHeight = function () {
        return $(".header-fill").height();
    };
    /**
     * Gets the footer height.
     * @return {number} The footer height.
     */
    Page.prototype.getFooterHeight = function () {
        return $(".pre-footer").height() + $("footer").height();
    };
    /**
     * Gets the page header height.
     * @return {number} The page header height.
     */
    Page.prototype.getPageHeaderHeight = function () {
        return $(".page-header-row").height();
    };
    /**
     * Gets the tab header height.
     * @return {number} The tab header height.
     */
    Page.prototype.getTabHeaderHeight = function () {
        return 70; // there should be a better way! this doesn't work -> $('<div class="title-wrapper"></div>').css('height');
    };
    /**
     * Gets the main container height (window height - header height).
     * @return {number} The main container height.
     */
    Page.prototype.getMainContainerHeight = function () {
        return this.getWindowHeight() - this.getHeaderHeight();
    };
    /**
     * Gets the maximum height.
     * @return {number} `this.getMainContainerHeight()`.
     */
    Page.prototype.getMaxHeight = function () {
        return this.getMainContainerHeight();
    };
    /**
     * Gets the page height.
     * @return {number} Content height - page header height.
     */
    Page.prototype.getPageHeight = function () {
        return this.getContentHeight() - this.getPageHeaderHeight();
    };
    /**
     * Gets the content height.
     * @return {number} Main container height - footer height.
     */
    Page.prototype.getContentHeight = function () {
        return this.getMainContainerHeight() - this.getFooterHeight();
    };
    /**
     * Gets the main content height.
     * @return {number} Window height - header height - page header height - footer height.
     */
    Page.prototype.getMainContentHeight = function () {
        return (this.getWindowHeight() -
            this.getHeaderHeight() -
            this.getPageHeaderHeight() -
            this.getFooterHeight());
    };
    /**
     * Gets the height for tab content.
     * @return {number} Window height - header height - footer height - tab header height.
     */
    Page.prototype.getTabContentHeight = function () {
        return (this.getWindowHeight() - this.getHeaderHeight() - this.getFooterHeight());
    };
    /**
     * Gets the page width.
     * @return {number} The width.
     */
    Page.prototype.getWidth = function () {
        return $(".page-container").width();
    };
    /**
     * Gets the width of the scroll container within the page body.
     * @return {number} The width.
     */
    Page.prototype.getScrollWidth = function () {
        return $("body > .scroll-container").width();
    };
    /**
     * Gets a string describing the size of the viewport.
     * @return {string} `"xs"` for extra small, `"sm"` for small, `"md"` for medium, and `"lg"` for large.
     */
    Page.prototype.getSize = function () {
        var size = "xs";
        if (mq("(min-width: 1200px)")) {
            size = "lg";
        }
        else if (mq("(min-width: 992px)")) {
            size = "md";
        }
        else if (mq("(min-width: 768px)")) {
            size = "sm";
        }
        return size;
    };
    /**
     * Gets a value indicating whether or not the page is "extra small".
     * @return {boolean} True if the page is extra small, otherwise false.
     */
    Page.prototype.isExtraSmall = function () {
        return this.getSize() == "xs";
    };
    /**
     * Gets a value indicating whether or not the page is "small".
     * @return {boolean} True if the page is small, otherwise false.
     */
    Page.prototype.isSmall = function () {
        return this.getSize() == "sm";
    };
    /**
     * Gets a value indicating whether or not the page is "medium".
     * @return {boolean} True if the page is medium, otherwise false.
     */
    Page.prototype.isMedium = function () {
        return this.getSize() == "md";
    };
    /**
     * Gets a value indicating whether or not the page is "large".
     * @return {boolean} True if the page is large, otherwise false.
     */
    Page.prototype.isLarge = function () {
        return this.getSize() == "lg";
    };
    return Page;
}(Evented_1.default));
var page = new Page();
$(window).on("resize", function () {
    page.trigger("update");
});
var POSSIBLE_SIZES = ["xs", "sm", "md", "lg"];
exports.POSSIBLE_SIZES = POSSIBLE_SIZES;
exports.default = page;
//# sourceMappingURL=Page.js.map


//////////////////
// WEBPACK FOOTER
// ./public/js/core/Page.js
// module id = 60
// module chunks = 1